<template>
	<div class="lo-wrap-logo">
		<img id="logo" src="../assets/Logo.png" alt="Logo of the bwHealthApp" />
		<h1 class="lo-name"><span class="lo-name-first">b</span><span class="lo-name-second">w</span><span>HealthApp</span></h1>
	</div>
</template>

<script>
import $ from 'jquery';
export default {
	name: 'Logo',
	props: ['scrollTop'],
	// watch: {
	// 	scrollTop: {
	// 		handler: function(newVal) {
	// 			if ($('.lo-wrap-logo').height() - newVal <= 100) {
	// 				$('.lo-wrap-logo').height(100);
	// 				$('.lo-wrap-logo').css('position', 'sticky');
	// 				$('.lo-wrap-logo').css('top', '0');
	// 				$('.lo-wrap-logo').css('width', '100%');
	// 				// $('.ho-wrap-content').css('text-align', 'left');

	// 				if (!this.mobile) {
	// 					$('.prev').css('display', 'block');
	// 					$('.next').css('display', 'block');
	// 					$('.download').css('display', 'block');
	// 					if (newVal - $('.de-wrap-description').height() - 20 > 0) {
	// 						$('.prev').css({
	// 							position: 'fixed',
	// 							top: window.innerHeight / 2 + 50,
	// 							left: '1%',
	// 						});
	// 						$('.next').css({
	// 							position: 'fixed',
	// 							top: window.innerHeight / 2 + 50,
	// 							right: '2%',
	// 						});
	// 						$('.download').css({
	// 							position: 'fixed',
	// 							top: 110,
	// 							right: '2%',
	// 						});
	// 					} else {
	// 						$('.prev').css({
	// 							position: 'absolute',
	// 							top: window.innerHeight / 2 + 50,
	// 							left: '1%',
	// 						});
	// 						$('.next').css({
	// 							position: 'absolute',
	// 							top: window.innerHeight / 2 + 50,
	// 							right: '2%',
	// 						});
	// 						$('.download').css({
	// 							position: 'absolute',
	// 							top: 0,
	// 							right: '2%',
	// 						});
	// 					}
	// 				}

	// 				let img = document.getElementById('logo');
	// 				img.width = 100 * this.image.ratio;
	// 				img.height = 100;
	// 				this.small = true;
	// 			} else {
	// 				let img = document.getElementById('logo');
	// 				img.width = (this.startHeight - newVal) * this.image.ratio;
	// 				img.height = this.startHeight - newVal;
	// 				$('.ho-wrap-content').css('text-align', 'center');
	// 			}
	// 		},
	// 	},
	// },
	data() {
		return {
			width: 0,
			height: 0,
			image: {},
			startHeight: 0,
			small: false,
			mobile: false,
			log: '',
		};
	},
	// mounted() {
	// 	if (this.isMobile()) {
	// 		this.mobile = true;
	// 	}
	// 	window.addEventListener('resize', this.resizeEvent);
	// 	let that = this;
	// 	if (this.mobile) {
	// 		setTimeout(function() {
	// 			let img = $('#logo');

	// 			let ratio = img.width() / img.height();
	// 			let availHeight = $('.lo-wrap-logo').height();

	// 			that.image = {
	// 				width: img.width(),
	// 				height: img.height(),
	// 				ratio: ratio,
	// 			};

	// 			$('#logo').css('max-height', 500);
	// 			$('#logo').css('max-width', 500 * ratio);

	// 			if (img.height() > availHeight) {
	// 				img.width(availHeight * ratio);
	// 				img.height(availHeight);
	// 			}
	// 			window.dispatchEvent(new Event('resize'));
	// 			setTimeout(function() {
	// 				that.startHeight = $('#logo').height();
	// 			}, 10);
	// 		}, 500);
	// 	} else {
	// 		setTimeout(function() {
	// 			let img = $('#logo');

	// 			let ratio = img.width() / img.height();
	// 			let availHeight = $('.lo-wrap-logo').height();

	// 			that.image = {
	// 				width: img.width(),
	// 				height: img.height(),
	// 				ratio: ratio,
	// 			};

	// 			$('#logo').css('max-height', 500);
	// 			$('#logo').css('max-width', 500 * ratio);

	// 			if (img.height() > availHeight) {
	// 				img.width(availHeight * ratio);
	// 				img.height(availHeight);
	// 			}
	// 			window.dispatchEvent(new Event('resize'));
	// 			setTimeout(function() {
	// 				that.startHeight = $('#logo').height();
	// 			}, 10);
	// 		}, 100);
	// 	}
	// },
	beforeDestroy() {
		window.removeEventListener('resize', this.resizeEvent);
	},
	methods: {
		isMobile() {
			try {
				document.createEvent('TouchEvent');
				return true;
			} catch (e) {
				return false;
			}
		},
		resizeEvent() {
			$('.ho-wrap-content').height(window.innerHeight);
			if (!this.small) {
				let img = document.getElementById('logo');

				let availWidth = $('.lo-wrap-logo').width();
				if (
					this.image.width > availWidth ||
					(this.image.height > availWidth / this.image.ratio && availWidth / this.image.ratio < window.innerHeight)
				) {
					img.width = availWidth;
					img.height = availWidth / this.image.ratio;
				}
			}
		},
	},
};
</script>

<style scoped>
.lo-wrap-logo {
	width: 100%;
	min-height: 100px;
	z-index: 2;
	/* background-color: var(--main-color-medium); */
	/* box-shadow: 0px 5px 50px 10px black; */
	/* border-bottom: 2px solid var(--main-color-border-dark); */
}

.lo-wrap-logo img {
	max-width: 80vw;
	margin: 20px auto 0px auto;
}

.lo-name {
	font-size: 13vw;
	margin: 0px;
	padding: 0px;
	font-family: Arial, Helvetica, sans-serif;
	color: #dddddd;
}

.lo-name-first {
	color: #ffde00;
}

.lo-name-second {
	color: #000000;
}
</style>
